(() => {
  'use strict';
  const container=document.querySelector('[data-vm-shopify-dealer]');
  if(!container)return;
  const en=document.documentElement.lang.startsWith('en');
  const copy=(de,english)=>en ? english : de;
  const fields=[
    ['first_name','Vorname','First name',true],['last_name','Nachname','Last name',true],
    ['email','E-Mail','Email',true],['phone_number','Telefon','Phone',false],
    ['custom#unternehmen_firmierung','Unternehmen / Firmierung','Company / legal name',true],
    ['custom#land','Land','Country',true],['custom#geschftsanschrift','Geschäftsanschrift','Business address',true],
    ['custom#website_optional','Website (optional)','Website (optional)',false],
    ['custom#kurzvorstellung_deines_unternehmens','Kurzvorstellung deines Unternehmens','Briefly introduce your company',true],
    ['custom#dein_vorhaben_mit_volta','Dein Vorhaben mit Volta','Your plans for Volta',true],
    ['custom#gewerbeanmeldung-field','Gewerbeanmeldung','Business registration document',true]
  ];
  const roots=new WeakSet(),forms=new WeakSet();
  function enhance(root){
    const form=root.querySelector('form');if(!form)return;
    if(!forms.has(form)){
      forms.add(form);
      const style=document.createElement('style');
      style.textContent=':host{--inline-container-max-width:100%!important;--container-max-w:100%!important}form[data-testid=form]{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:20px}form>div,form>fieldset{min-width:0}.vm-dealer-heading,.vm-dealer-wide,form>button[type=submit],form>div:first-child:empty{grid-column:1/-1}.vm-dealer-heading{font:700 22px/1.3 Arial,sans-serif;color:#14212d;border-top:1px solid #d9dfe1;padding-top:22px;margin:16px 0 0}.vm-dealer-heading:first-of-type{border:0;padding:0;margin:0}form :focus-visible{outline:3px solid #14212d;outline-offset:3px}form>button[type=submit]{justify-self:start;min-height:48px}@media(max-width:600px){form[data-testid=form]{grid-template-columns:minmax(0,1fr)}form>button[type=submit]{width:100%}}';
      root.append(style);
    }
    const headings={'first_name':copy('Deine Kontaktdaten','Your contact details'),'custom#unternehmen_firmierung':copy('Dein Unternehmen','Your company'),'custom#kurzvorstellung_deines_unternehmens':copy('Dein Vorhaben','Your plans'),'custom#gewerbeanmeldung-field':copy('Gewerbeanmeldung hochladen','Upload business registration')};
    const ordered=[];
    for(const [id,de,english,required] of fields){
      const field=root.getElementById(id)||form.querySelector(`[name="${id}"]`);if(!field)continue;
      field.id=id;
      field.setAttribute('aria-label',copy(de,english));
      if(required)field.setAttribute('aria-required','true');
      let row=field;while(row.parentElement && row.parentElement!==form)row=row.parentElement;
      if(row.parentElement!==form || ordered.includes(row))continue;
      if(headings[id]){
        let heading=form.querySelector(`[data-vm-dealer-heading="${id}"]`);
        if(!heading){heading=document.createElement('h3');heading.className='vm-dealer-heading';heading.dataset.vmDealerHeading=id;heading.textContent=headings[id];}
        ordered.push(heading);
      }
      if(field.tagName==='TEXTAREA'||field.type==='file')row.classList.add('vm-dealer-wide');
      const label=root.getElementById('label-'+id)||(field.type==='file' ? row.querySelector('p') : null);
      if(required && label && !label.textContent.trim().endsWith('*'))label.append(' *');
      ordered.push(row);
    }
    const anchor=[...form.children].find(el=>el.querySelector('button[type=submit]')||el.matches('button[type=submit]'));
    if(anchor)ordered.forEach(row=>form.insertBefore(row,anchor));
  }
  function attach(){
    const root=container.querySelector('shopify-forms-embed')?.shadowRoot;if(!root||roots.has(root))return;
    roots.add(root);const observer=new MutationObserver(()=>{observer.disconnect();enhance(root);observer.observe(root,{childList:true,subtree:true});});
    enhance(root);observer.observe(root,{childList:true,subtree:true});
  }
  const timer=setInterval(attach,250);attach();setTimeout(()=>clearInterval(timer),30000);
})();
